/**
 * Represents a cancellation caused by navigating away
 * before the previous transition has fully resolved.
 */
function Cancellation() {}

module.exports = Cancellation;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-router/modules/Cancellation.js
 ** module id = 151
 ** module chunks = 0
 **/